import type { TaskResult } from "../types";

function normalizeFormula(value: string | undefined): string {
  return (value ?? "")
    .replace(/\$/g, "")
    .replace(/\s+/g, "")
    .replace(/^=/, "")
    .toUpperCase();
}

export async function gradeProject15(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Trimestre 1");
      const table = sheet.tables.getItemAt(0);
      table.load("showTotals");
      await context.sync();

      results.push({ taskId: 1, passed: table.showTotals === true });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: MAX en E12 o E13 (la fila de totales puede empujar "Máximo" hacia abajo)
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Trimestre 1");
      const e12 = sheet.getRange("E12");
      const e13 = sheet.getRange("E13");
      e12.load("formulas,values");
      e13.load("formulas,values");
      await context.sync();

      const checkMax = (cell: Excel.Range): boolean => {
        const formula = normalizeFormula(String(cell.formulas[0][0] ?? ""));
        const value = Number(cell.values[0][0]);
        return (
          (formula.includes("MAX(") || formula.includes("MAXA(")) &&
          value === 80
        );
      };

      results.push({ taskId: 2, passed: checkMax(e12) || checkMax(e13) });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Trimestre 1");
      const charts = sheet.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      for (const chart of charts.items) {
        chart.load("chartType,top");
        await context.sync();
        if (
          String(chart.chartType).toLowerCase().includes("pie") &&
          Number(chart.top) > 180
        ) {
          passed = true;
          break;
        }
      }

      results.push({ taskId: 3, passed });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Trimestre 2");
      const tables = sheet.tables;
      tables.load("items");
      await context.sync();

      let passed = false;
      if (tables.items.length > 0) {
        const table = tables.items[0];
        table.load("style");
        const range = table.getRange();
        range.load("address");
        await context.sync();

        const address = String(range.address).replace(/\$/g, "").toUpperCase();
        // Only check "Light14" — color prefix varies across Excel versions
        passed =
          address.includes("A2:E10") &&
          String(table.style).toUpperCase().includes("LIGHT14");
      }

      results.push({ taskId: 4, passed });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Diseño rápido 2 — en gráficos de barras, Quick Layout 2 muestra
  // etiquetas de datos (dataLabels.showValue) en las series.
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Trimestre 1");
      const charts = sheet.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      for (const chart of charts.items) {
        chart.load("chartType");
        await context.sync();

        // Check the bar chart (not pie)
        if (String(chart.chartType).toLowerCase().includes("bar")) {
          const series0 = chart.series.getItemAt(0);
          series0.dataLabels.load("showValue");
          await context.sync();

          passed = series0.dataLabels.showValue === true;
          break;
        }
      }

      results.push({ taskId: 5, passed });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
